// React
import React from 'react';
// Redux
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
// componentes
import Title from 'components/TitleWithIcon';
import FiltrosEstadisticasSolicitudes from './Filtros/index'
import TabMenu from '../MenuListadoReportes'

function ActaVencimientoDePlazoParaDeclararCambioDeResidenciaDeUnMunicipioAOtro (props) {
    return (
        <TabMenu
            componenteEntrante={
                <div style={{backgroundColor:'#D4D8E1'}}>
                    <Title title={props.titulo} icon={"/assets/Reporte.png"}/>
                    <FiltrosEstadisticasSolicitudes />            
                </div>
            }
        />
    )
}
export default connect(mapStateToProps, mapDispatchToProps)(ActaVencimientoDePlazoParaDeclararCambioDeResidenciaDeUnMunicipioAOtro);